/**
 * Labstep
 *
 * @module screens/Group/Show/Center/Discussion
 * @desc Discussion for a group
 */

import { LayoutMainContentCenter } from 'labstep-web/components/Layout/MainContent/Center';
import { ThreadForm } from 'labstep-web/components/Thread/Form';
import { Card } from 'labstep-web/core/Card/Card';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import styles from './styles.module.scss';
import type { IScreensThreadProps } from './types';

export const ScreensThread: React.FC<IScreensThreadProps> = ({
  thread,
}) => (
  <div className={styles.container}>
    <LayoutMainContentCenter>
      <Card id="information-card" className={styles.threadContainer}>
        <ThreadForm
          disableAutoScroll
          entityNameLabel="comments"
          readThreadIds={thread.id}
          createThreadId={thread.id}
          noCommentsMessage={
            <CardEmptyState
              src="/img/empty-state/comments.svg"
              title="No comments"
              explanation="Start a discussion with workspace members."
            />
          }
        />
      </Card>
    </LayoutMainContentCenter>
  </div>
);
